import React, { useEffect } from 'react';
import logo from '../../assets/img/Xtract-Login.png';
import moment from 'moment';




const Loginsucess = () => {


  useEffect(() => {
  const handleStorageChange = (event) => {
    if (event.key === "logout") {
      // User logged out in another tab
      window.location.href = "/login"; // or use navigate('/login')
    }
  };

  window.addEventListener("storage", handleStorageChange);

  return () => {
    window.removeEventListener("storage", handleStorageChange);
  };
  }, []);

   
    return (
        <React.Fragment>
            <section style={{width:"100%",display:"flex",justifyContent:"center"}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column"}}>
          
                        <div style={{maxWidth:"700px",marginTop:"50px"}} >
                            <img src={logo} className='img-fluid' alt="xtract" />
                        </div>
                       <div style={{marginTop:"100px",display:"flex",justifyContent:"center"}}>
                        <span style={{color:"rgb(25, 109, 138)",fontWeight:"bold",fontSize:"30px"}}>You're already logged in on another tab</span>

                       </div>
                       <div>
                <button
    onClick={() => window.location.href = '/login'}
    style={{
      marginTop: "20px",
      padding: "10px 20px",
      backgroundColor: "#176c89",
      color: "white",
      border: "none",
      borderRadius: "5px",
      cursor: "pointer",
      fontSize: "16px",
      fontWeight: "bold"
    }}
  >
    Back to Login

  </button>
                       </div>
         
                    
                </div>
                <div className='login-footer-position'>
                    <span className='' style={{ color: '#176c89', fontSize: "0.8em" }}>
                        Copyright <i className="bi bi-c-circle  fw-bolder"></i> {moment().year()} <a href='http://www.zaparetech.com/' target="_blank" style={{ textDecoration: 'none', color: '#176c89' }} className='' >DataBlocks Inc dba Zapare Technologies.</a> All rights reserved.
                    </span>
                </div>
            </section>

        </React.Fragment>
    );
}

export default Loginsucess;
